import { create, filter, findAll, getOne, update } from "@/store/Crud/functions/actions";
import { SET_SUCCESS } from "./types";
export const resetSuccess = (store) => {
    store.commit(SET_SUCCESS, false);
};
export default {
    create,
    filter,
    getOne,
    update,
    findAll,
    resetSuccess,
};
